<template>
  <el-table :data="tableData" stripe v-loading="loading" ref="tablePrepost" size="mini" style="width: 100%">
    <el-table-column sortable prop="id" label="Número Atendimento"></el-table-column>
    <el-table-column sortable prop="name" label="Nome"></el-table-column>
    <el-table-column sortable prop="createdAt" label="Data"></el-table-column>
    <el-table-column label="Marketplace">
      <template slot-scope="scope">
        <span v-if="getMarketplaces(scope.row)">
          {{ getMarketplaces(scope.row).join(', ') }}
        </span>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column width="270" align="right">
      <template slot="header" slot-scope="scope">
        <span v-if="tableData.length">
          <el-button type="text" @click="pdf()"><i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;PDF</el-button>
          <el-button type="text" @click="csv()"><i class="fa fa-file-excel-o" aria-hidden="true"></i>&nbsp;CSV</el-button>
        </span>
      </template>
      <template slot-scope="scope">
        <el-button size="small" title="Comprovante de postagem" icon="el-icon-document"
          @click="proof(scope.$index, scope.row)" circle></el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import { PdvDashboardService } from "@/services/pdv/pdv.dashboard.services";
import { PdvService } from "@/services/pdv/pdv.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "PdvMarketplaceObject",
  props: ["customer", "startedAt", "finishedAt"],
  data() {
    return {
      loading: false,
      tableData: [],
    };
  },
  methods: {
    hasObjects(row) {
      return Array.isArray(row.plp)
        && row.plp.some(p => Array.isArray(p.tags) && p.tags.length > 0);
    },
    getMarketplaces(row) {
      if (!row.plp || !Array.isArray(row.plp)) return null;

      const marketplaces = row.plp
        .flatMap(p => Array.isArray(p.tags) ? p.tags : [])
        .map(t => t.marketplace)
        .filter(Boolean);

      return marketplaces.length ? marketplaces : null;
    },
    pdf() {
      this.fetch({
        action: 'export',
        type: 'pdfMarketplace'
      })
    },
    csv() {
      this.fetch({
        action: 'export',
        type: 'csvMarketplace'
      })
    },
    proof(index, row) {
      const vm = this;
      vm.loading = true;
      PdvService.proof(row.id, row.key, row.createdBy)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `atendimento.${row.id}.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => vm.loading = false);
    },
    fetch(options) {
      const vm = this;
      vm.loading = true;
      const s = moment(vm.startedAt);
      const f = moment(vm.finishedAt);
      if (!options) {
        options = {
          action: 'table',
          type: ''
        }
      }
      PdvDashboardService.list(
        s.format("YYYY-MM-DD"),
        f.format("YYYY-MM-DD"),
        vm.customer,
        options.action,
        options.type
      )
        .then((response) => {
          if (options.action !== 'export') {
            vm.tableData = response.filter((row) => vm.hasObjects(row));
            vm.$emit('update', 'marketplace', vm.tableData.length)
          } else {
            var downloadLink = document.createElement("a");
            downloadLink.href = response;
            downloadLink.download = options.type === 'pdfMarketplace' ? `atendimento.pdf` : `atendimento.csv`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          }
        })
        .catch((error) => {
          this.$message({ type: "error", duration: 5000, message: error });
        })
        .finally(() => vm.loading = false);
    },
  },
};
</script>